module.exports = __webpack_public_path__ + "static/media/DSC04771.bebb1046.png";